var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingApi } from './apis/ai-tagging-api.interface';
import { DISABLED_SCOPE_OPTIONS, THRESHOLD_MARKS_MAP } from '../constants';
import _ from 'lodash';
import { NodeListRepository } from './node-list-repository.interface';
import { DateFormatterService } from '@/infrastructure/utils/util-services/date-formatter/type/date-formatter-service.interface';
import { DataScopeField, AiTaggingType } from '../enums';
let AiTaggingRepositoryImpl = class AiTaggingRepositoryImpl {
    constructor(_aiTaggingApi, _nodeListRepository, _dateFormatterService) {
        this._aiTaggingApi = _aiTaggingApi;
        this._nodeListRepository = _nodeListRepository;
        this._dateFormatterService = _dateFormatterService;
    }
    getFields(params) {
        return this._aiTaggingApi.getFieldsApi(params);
    }
    showField(params) {
        return this._aiTaggingApi.postFolderFieldSettingsApi(params);
    }
    getNodes(folderId, fieldId) {
        return this._aiTaggingApi.getNodesApi(folderId, fieldId).then(data => {
            return this._nodeListRepository.parseNodesApiResult(data);
        });
    }
    parsingNode(params) {
        return this._aiTaggingApi.parsingNodeApi({
            folder_id: params.folderId,
            field_id: params.fieldId,
            node_id: params.nodeId,
            parent_id: params.parentIds,
        }).then(data => {
            return {
                nodeId: data.node_id,
                context: data.node_desc,
                updatedTime: this._dateFormatterService.formatDate(data.updated_at),
            };
        });
    }
    reParsingNode(params) {
        return this._aiTaggingApi.reParsingNodeApi({
            folder_id: params.folderId,
            field_id: params.fieldId,
            node_id: params.nodeId,
            parent_id: params.parentIds,
        }).then(data => {
            return {
                nodeId: data.node_id,
                context: data.node_desc,
                updatedTime: this._dateFormatterService.formatDate(data.updated_at),
            };
        });
    }
    updateNodeSummaryByNodeId(params) {
        return this._aiTaggingApi.updateNodeSummaryByNodeIdApi({
            field_id: params.fieldId,
            node_id: params.nodeId,
            user_node_desc: params.context,
        }).then(data => {
            return {
                nodeId: data.node_id,
                context: data.node_desc,
                updatedTime: this._dateFormatterService.formatDate(data.updated_at),
            };
        });
    }
    startTagging(taggingParams) {
        if (taggingParams && taggingParams.version === 'V3') {
            return this._aiTaggingApi.startMaxTaggingApi({
                folder_id: taggingParams.folderId,
                field_id: taggingParams.fieldId,
                patent_search_param: taggingParams.searchParam,
                select_item_ids: taggingParams.nodeIds,
                content_options: _.map(_.filter(taggingParams.taggingSetting.dataScope, item => !_.includes(DISABLED_SCOPE_OPTIONS, item)), (item) => item === DataScopeField.CLMS ? 'claim' : item),
                multi_label: taggingParams.taggingSetting.taggingType === AiTaggingType.MULTI,
                prob_value: taggingParams.taggingSetting.threshold / 100, // prob_value的取值为 0.1 - 0.9
                model_type: taggingParams.taggingSetting.aiModel,
            });
        }
        else {
            return this._aiTaggingApi.startTaggingApi({
                folder_id: taggingParams.folderId,
                field_id: taggingParams.fieldId,
                patent_search_param: taggingParams.searchParam,
                select_item_ids: taggingParams.nodeIds,
                multi_label: taggingParams.taggingSetting.taggingType === AiTaggingType.MULTI,
                prob: _.lowerCase(THRESHOLD_MARKS_MAP[taggingParams.taggingSetting.threshold]),
            });
        }
    }
    getTaggingResult(params) {
        return this._aiTaggingApi.getTaggingResultApi(params).then(data => {
            return {
                ...data,
                total_patent_count: this._convertToPositiveNumber(data.total_patent_count),
                label_patent_count: this._convertToPositiveNumber(data.label_patent_count),
                recall_patent_count: this._convertToPositiveNumber(data.recall_patent_count),
                available_patent_count: this._convertToPositiveNumber(data.available_patent_count),
            };
        });
    }
    _convertToPositiveNumber(value) {
        return value && value > 0 ? value : 0;
    }
};
AiTaggingRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingApi)),
    __param(1, inject(NodeListRepository)),
    __param(2, inject(DateFormatterService)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingApi !== "undefined" && AiTaggingApi) === "function" ? _a : Object, typeof (_b = typeof NodeListRepository !== "undefined" && NodeListRepository) === "function" ? _b : Object, typeof (_c = typeof DateFormatterService !== "undefined" && DateFormatterService) === "function" ? _c : Object])
], AiTaggingRepositoryImpl);
export { AiTaggingRepositoryImpl };
